
import { motion } from "framer-motion";
import { useState } from "react";

const LocationMap = () => {
  const mapLink = "https://maps.app.goo.gl/ZRuzfQbKpDAkjNaW7?g_st=com.google.maps.preview.copy";
  const [isLoaded, setIsLoaded] = useState(false);
  
  const handleMapClick = () => {
    window.open(mapLink, '_blank', 'noopener,noreferrer');
  };

  return (
    <motion.div 
      className="mt-12" 
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: 0.6 }}
    >
      <div 
        className="bg-black p-8 rounded-lg shadow-lg border border-white/20 cursor-pointer hover:bg-black/80 transition-colors overflow-hidden"
        onClick={handleMapClick}
      >
        <div className="text-center mb-6">
          <h3 className="text-2xl font-bold text-white mb-2">Nasza lokalizacja</h3>
          <p className="text-white/90 mb-4">
            061 Garage Detailing Studio<br />
            ul. Bluszczowa, Poznań 61-001<br />
            Kliknij, aby zobaczyć szczegóły na mapie
          </p>
        </div>
        
        {/* Interactive Map Preview */}
        <div className="relative w-full h-80 bg-black rounded-lg overflow-hidden mb-6">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2432.1234567890!2d16.925200000000!3d52.406400000000!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470444d775e8b5e9%3A0x1234567890abcdef!2sBluszczowa%2C%20Pozna%C5%84!5e0!3m2!1spl!2spl!4v1620000000000!5m2!1spl!2spl&q=ul.+Bluszczowa+Poznan+61-001"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="rounded-lg"
            onLoad={() => setIsLoaded(true)}
          />
          {!isLoaded && (
            <div className="absolute inset-0 flex items-center justify-center bg-black rounded-lg">
              <div className="text-white text-lg">Ładowanie mapy...</div>
            </div>
          )}
        </div>

        <div className="text-center">
          <div className="inline-flex items-center gap-2 bg-garage-blue hover:bg-blue-700 text-white px-6 py-3 rounded-md transition-colors">
            <span>Otwórz w Google Maps</span>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default LocationMap;
